// index.js
import './bootstrap'
import Vue from 'vue'
import VueScreen from 'vue-screen';
import Calendar from './components/Calendar'
Vue.config.productionTip = false

// Set breakpoints and
Vue.use(VueScreen, {
    sm: '320px',
    md: '750px',
    lg: '1000px',
    handheld: screen => !screen.lg,
});

new Vue({
    el: '#attendable-vue-calendar',
    components: {
        Calendar
    }
})
